import React from 'react';
import ReactDOM from 'react-dom';

class CheckboxQuestion extends React.Component {
	state = {
	  selectedAnswers: [],
	};

	handleChange = (e) => {
	  const currentAnswers = this.state.selectedAnswers;
	  if (!e.target.checked) {
	    const _this = this;
	    currentAnswers.map((item, index) => {
	      if (item === e.target.value) {
	        currentAnswers.splice(index, 1);
	      }
	    });
	  } else {
	    currentAnswers.push(e.target.value);
	  }
	  this.setState({ selectedAnswers: currentAnswers });
	  const data = {};
	  data[this.props.name] = currentAnswers;
	  this.props.setFormData(data);
	};

	handleClick = (e) => {
	  let checkboxToClick = ReactDOM.findDOMNode(e.target);

	  if (typeof checkboxToClick !== 'undefined') {
	    checkboxToClick = checkboxToClick.getElementsByClassName('checkboxToClick');
	    checkboxToClick = checkboxToClick[0];
	  }

	  if (typeof checkboxToClick !== 'undefined') {
	    checkboxToClick.click();
	  }
	};

	render() {
	  const answerOptions = [];
	  for (let i = 0; i < this.props.answers.length; i++) {
	    answerOptions.push((
  <div
    className="g-b g-b--1of3 form-checkbox"
    key={this.props.answers[i]._id}
  >
    <label className="dib" htmlFor={this.props.name} onClick={e => this.handleClick(e)}>
      <input type="hidden" name={this.props.name} />
      <input
        type="checkbox"
        className="checkboxToClick"
        onChange={this.handleChange}
        name={this.props.name}
        value={this.props.answers[i]._id}
        title={this.props.answers[i].title}
      />
      {this.props.answers[i].title}
    </label>
  </div>));
	  }
	  return (
  <div className="form-group">
    {answerOptions}
  </div>
	  );
	}
}

module.exports = CheckboxQuestion;
